/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/unit': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M20 21.928L6 16l14-5.928zM21 14.229s5 .493 5 1.771c0 1.277-5 1.771-5 1.771v-3.542z"/>'
  }
})
